"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var searchActions = _interopRequireWildcard(require("../actions/searchActions"));

var _initialState = _interopRequireDefault(require("./initialState"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function updateCustomerInfo(state, action) {
  return state.customerDetails[0].party.contactMedium.map(function (content) {
    switch (content.mediumType) {
      case 'PostalAddress':
        return _objectSpread(_objectSpread({}, content), {}, {
          characteristic: action.payload.contactMedium.find(function (e) {
            return e.mediumType === 'address';
          }).characteristic
        });

      case 'Telephone':
        return _objectSpread(_objectSpread({}, content), {}, {
          characteristic: action.payload.contactMedium.find(function (e) {
            return e.mediumType === 'VodafoneTelephone';
          }).characteristic
        });

      case 'Email':
        return _objectSpread(_objectSpread({}, content), {}, {
          characteristic: action.payload.contactMedium.find(function (e) {
            return e.mediumType === 'Email';
          }).characteristic
        });

      default:
        return _objectSpread({}, content);
    }
  });
}

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState.default;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case searchActions.GET_CUSTOMER_SEARCH_DATA_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          customerDetails: [],
          isFetchingData: true,
          type: action.payload.name,
          value: action.payload.value,
          error: null
        });
      }

    case searchActions.GET_CUSTOMER_SEARCH_DATA_SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isFetchingData: false,
          showResult: true,
          customerDetails: _toConsumableArray(action.payload),
          error: null
        });
      }

    case searchActions.GET_CUSTOMER_SEARCH_DATA_FAILURE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isFetchingData: false,
          customerDetails: [],
          showResult: false,
          type: '',
          value: '',
          error: action.payload
        });
      }

    case searchActions.RESET_CUSTOMER_SEARCH_DATA:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          showResult: false,
          isFetchingData: false,
          type: '',
          value: '',
          showDialog: action.payload,
          error: null,
          customerDetails: []
        });
      }

    case searchActions.RESET_CUSTOMER_SEARCH_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          error: null
        });
      }

    case searchActions.GET_IMPERSONATION_TOKEN_SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          impersonationToken: action.payload
        });
      }

    case searchActions.SET_INSTANCE_ID:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          instanceId: action.payload
        });
      }

    case searchActions.UPDATE_CUSTOMER_INFO_SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          customerDetails: [_objectSpread(_objectSpread({}, state.customerDetails[0]), {}, {
            party: _objectSpread(_objectSpread({}, state.customerDetails[0].party), {}, {
              fullName: action.payload.fullName,
              familyName: action.payload.familyName,
              firstName: action.payload.givenName,
              contactMedium: updateCustomerInfo(state, action)
            })
          })]
        });
      }

    case searchActions.SET_SEARCH_QUERY_PARAMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        queryParam: action.payload
      });

    default:
      return state;
  }
};

exports.default = _default;